document.addEventListener("DOMContentLoaded", function() {

/* ==================================
   NORMALIZE OPTION NAME (multi-language)
================================== */
function normalizeOptionName(name) {
  if (!name) return "";
  const lower = name.toLowerCase().trim();

  const sizeWords = [
    "size","taille","tamaño","tamanho","misura","größe","groesse","grosse",
    "maat","størrelse","storrelse","storlek","koko","rozmiar","velikost",
    "méret","meret","mărime","marime","μέγεθος","megethos","размер","razmer",
    "veličina","velicina","dydis","izmērs","izmers","suurus",
    "サイズ","さいず","寸法","大きさ"
  ];
  if (sizeWords.includes(lower)) return "size";

  const baseWords = [
    "base","fond","type de base","basis","tipo base","sockel","bunn","botten","pohja","podstawa","základ",
    "zaklad","spodek","alap","bază","baza","βάση","vasi","основа","osnova",
    "pamata","pamats","põhi","台座","ベース","べーす","基部"
  ];
  if (baseWords.includes(lower)) return "base";

  const colourWords = [
    "color","colour","couleur","colores","colours","cores","farbe","farben",
    "farver","färger","farger","väriä","barvy","boje","barve","culori","kolor","kleur","kleuren",
    "χρώματα","цвета","カラー","色"
  ];
  if (colourWords.some(w => lower.includes(w))) return "color";

  return lower;
}

/* ==================================
   NORMALIZE OPTION VALUE
================================== */
function normalizeOptionValue(group, value) {
  const v = (value || "").toLowerCase().trim();

  if (group === "base") {
    const plugWords = [
      "plug-compatible","compatible-plug","plug compatible","compatible with plug",
      "with plug","compatible avec prise","compatible avec les prises","compatible prise",
      "compatible con enchufes","compatible con enchufe","compatível com tomada",
      "compatível tomada","compatibile con presa","compatibile presa",
      "kompatibel mit stecker","kompatibel stecker","kompatibel mit buchse","plug-kompatibel","kompatybilna z korkiem",
      "met plug","met stekker","plug-compatibel","プラグ互換","プラグ対応","プラグ 互換","プラグ 対応"
    ];

    if (plugWords.some(w => v.includes(w))) return "plug-compatible";
  }

  return v;
}

function slugOptionValue(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ł/g, "l")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/* ==================================
   CANONICAL VALUE MAP
================================== */
window.variantValueMap = window.variantValueMap || {
  size: {
    "cute": "cute",
    "schattig": "cute",
    "lindo": "cute",
    "mignon(ne)": "cute",
    "herculean": "herculean",
    "herkulisch": "herculean",
    "herkulesowy": "herculean",
    "herkulesowy": "herculean",
    "hercúleo": "herculean",
    "grande": "herculean",
    "herculeen": "herculean",
    "mammoth": "mammoth",
    "mammoet": "mammoth",
    "mamuci": "mammoth",
    "mamut": "mammoth",
    "gargantuan": "gargantuan",
    "gigantisch": "gargantuan",
    "gigantyczny": "gargantuan",
    "gargantuiczny": "gargantuan",
    "ogromny": "gargantuan",
    "olbrzymi": "gargantuan",
    "mignon": "cute",
    "herculéen": "herculean",
    "mamút": "mammoth",
    "マンモス": "mammoth",
    "söt": "cute",
"sot": "cute",
"herkulisk": "herculean",
"mammut": "mammoth",
"gigantisk": "gargantuan",
    "gargantuesco": "gargantuan"
  },

  base: {
    "flat": "flat",
    "plaska": "flat",
    "plaski": "flat",
    "flach": "flat",
    "płaska": "flat",
    "plana": "flat",
    "plat": "flat",
    "plate": "flat",
    "departamento": "flat",
    "フラット": "flat",
    "suction-cup": "suction-cup",
    "met zuignap": "suction-cup",
    "met-zuignap": "suction-cup",
    "z-przyssawka": "suction-cup",
    "przyssawka": "suction-cup",
    "saugnapf": "suction-cup",
    "ventosa": "suction-cup",
    "ventouse": "suction-cup",
    "吸盤": "suction-cup",
    "compatible avec plug": "plug-compatible",
    "kompatybilna z korkiem": "plug-compatible",
    "kompatybilna-z-korkiem": "plug-compatible",
    "kompatybilna-z-korkiem-analnym": "plug-compatible",
    "kompatybilna-z-plugiem": "plug-compatible",
    "kompatybilny-z-korkiem": "plug-compatible",
    "kompatybilny-z-korkiem-analnym": "plug-compatible",
    "plug-compatible": "plug-compatible",
    "plug-compatibel": "plug-compatible",
    "plug-kompatibel": "plug-compatible",
    "compatible con plug": "plug-compatible",
    "プラグ対応": "plug-compatible",
    "platt": "flat",
"sugkopp": "suction-cup",
"pluggkompatibel": "plug-compatible",
  },

  color: {
    "common": "common",
    "vanlig": "common",
    "standaard": "common",
    "pospolity": "common",
    "zwykly": "common",
    "commun": "common",
    "común": "common",
    "epic": "epic",
    "episk": "epic",
    "episch": "epic",
    "epicki": "epic",
    "épique": "epic",
    "epicki": "epic",
    "épico": "epic",
    "heroic": "heroic",
    "heroisk": "heroic",
    "heroisch": "heroic",
    "heroiczny": "heroic",
    "heroiczny": "heroic",
    "heroico": "heroic",
    "héroïque": "heroic",
    "legendary": "legendary",
    "legendarisch": "legendary",
    "legendarny": "legendary",
    "légendaire": "legendary",
    "legendario": "legendary",
    "legendarisk": "legendary",
    "sorpresa": "surprise",
    "överraskning": "surprise",
    "verrassing": "surprise",
    "niespodzianka": "surprise",
    "Niespodzianka": "surprise",
    "surprise": "surprise"
  }
};

function getCanonicalOptionValue(group, value) {
  const normalizedGroup = normalizeOptionName(group);
  const cleanedValue = normalizeOptionValue(normalizedGroup, value);
  const sluggedValue = slugOptionValue(cleanedValue);
  const map = window.variantValueMap?.[normalizedGroup] || {};
  const mappedValue = map[cleanedValue] || map[sluggedValue];

  if (mappedValue) return mappedValue;

  if (normalizedGroup === "base") {
    if (sluggedValue.includes("przyssawka") || sluggedValue.includes("zuignap")) return "suction-cup";
    if (sluggedValue.includes("plaska") || sluggedValue === "plat") return "flat";
    if (sluggedValue.includes("korkiem") || sluggedValue.includes("plug") || sluggedValue.includes("compatibel")) return "plug-compatible";
  }

  if (normalizedGroup === "size") {
    if (sluggedValue.includes("herkul")) return "herculean";
    if (sluggedValue.includes("mamut") || sluggedValue.includes("mammoet")) return "mammoth";
    if (sluggedValue.includes("gigant") || sluggedValue.includes("gargant") || sluggedValue.includes("ogrom") || sluggedValue.includes("olbrzym")) return "gargantuan";
    if (sluggedValue.includes("urocz") || sluggedValue.includes("slodk") || sluggedValue.includes("sliczn") || sluggedValue.includes("schattig")) return "cute";
  }

  if (normalizedGroup === "color") {
    if (sluggedValue.includes("legendarn") || sluggedValue.includes("legendarisch")) return "legendary";
    if (sluggedValue.includes("heroicz") || sluggedValue.includes("heroisch")) return "heroic";
    if (sluggedValue.includes("epick") || sluggedValue.includes("episch")) return "epic";
    if (sluggedValue.includes("niespodziank") || sluggedValue.includes("verrassing")) return "surprise";
    if (sluggedValue.includes("standaard")) return "common";
  }

  return sluggedValue || cleanedValue.replace(/\s+/g, "-");
}

/* ================
   GALLERY SWAP
================ */
const thumbnails = document.querySelectorAll(".thumbnail");
const mainBanner = document.getElementById("main-banner");

function swapMainSrc(newSrc) {
  if (!mainBanner || !newSrc) return;
  mainBanner.classList.add("is-fading");
const img = new Image();
img.onload = () => {
  mainBanner.src = newSrc;
  mainBanner.srcset = newSrc;   // ← REQUIRED FIX
  requestAnimationFrame(() => mainBanner.classList.remove("is-fading"));
};
img.onerror = () => mainBanner.classList.remove("is-fading");
img.src = newSrc;
}

thumbnails.forEach((thumb) => {
  thumb.addEventListener("click", function () {
    thumbnails.forEach(t => t.classList.remove("selected"));
    this.classList.add("selected");
    swapMainSrc(this.dataset.large || this.src);
  });
});

/* ================
   MOBILE SWIPE
================ */
(function () {
  if (!mainBanner) return;
  const thumbs = Array.from(document.querySelectorAll(".thumbnail"));
  if (!thumbs.length) return;

  let currentIndex = thumbs.findIndex(el => el.classList.contains("selected"));
  if (currentIndex < 0) currentIndex = 0;

  let startX = 0, startY = 0, swiping = false;

  function goTo(idx) {
    currentIndex = (idx + thumbs.length) % thumbs.length;
    thumbs.forEach(x => x.classList.remove("selected"));
    const t = thumbs[currentIndex];
    t.classList.add("selected");
    swapMainSrc(t.dataset.large || t.src);
  }

  mainBanner.addEventListener("touchstart", e => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    swiping = true;
  }, { passive: true });

  mainBanner.addEventListener("touchend", e => {
    if (!swiping) return;
    swiping = false;

    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;

    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) goTo(currentIndex + 1);
      else goTo(currentIndex - 1);
    }
  });
})();

/* ==================================
   VARIANT SELECTION LOGIC
================================== */

const form = document.querySelector("form[id^='product-form-']");
const hiddenInput = form?.querySelector("input[name='id']");
const addToCartBtn = document.querySelector("button[id^='add-to-cart-']");
const addToCartWrap = addToCartBtn?.closest(".add-to-cart-wrapper");
const hintEl = document.querySelector("p[id^='selection-hint-']");
if (hintEl && addToCartWrap && hintEl.parentElement !== addToCartWrap) {
  addToCartWrap.appendChild(hintEl);
}
const optionButtons = form?.querySelectorAll(".option-btn") || [];

const variants = window.productVariants;
const productHandle = window.productHandle;
const totalOptions = window.productOptionsSize;

// === Stable option order (DOM order) ===
// This MUST match the order Shopify uses for variant.options[] (option1, option2, option3...)
const groupOrder = (() => {
  // Prefer variant-frame order if present
  const frames = Array.from(document.querySelectorAll(".variant-frame"));
  const ordered = [];

  frames.forEach(frame => {
    const btn = frame.querySelector(".option-btn[data-option-group]");
    if (!btn) return;
    const g = btn.dataset.optionGroup;
    if (g && !ordered.includes(g)) ordered.push(g);
  });

  // Fallback: first-seen order in DOM
  if (!ordered.length) {
    document.querySelectorAll(".option-btn[data-option-group]").forEach(b => {
      const g = b.dataset.optionGroup;
      if (g && !ordered.includes(g)) ordered.push(g);
    });
  }

  return ordered;
})();

function arraysEqualCI(a, b) {
  if (!a || !b || a.length !== b.length) return false;
  return a.every((x, i) => {
    const group = groupOrder[i] || "";
    return getCanonicalOptionValue(group, x) === getCanonicalOptionValue(group, b[i]);
  });
}

function getSelectedVariantOptions() {
  // Always return array aligned to Shopify variant.options[] indices
  const out = new Array(totalOptions).fill("");

  groupOrder.forEach((group, idx) => {
    if (idx >= totalOptions) return;
    const active = form.querySelector(`.option-btn[data-option-group="${group}"].active`);
    if (active) out[idx] = active.dataset.value || "";
  });

  return out;
}


function clearStandardGroup(group) {
  form.querySelectorAll(`.option-btn[data-option-group="${group}"]`).forEach(button => {
    button.classList.remove("active");
    button.setAttribute("aria-pressed", "false");
  });
}

function addStandardResetControl(frame, group) {
  if (!frame || frame.querySelector(':scope > .ls-option-reset-btn')) return;

  const button = document.createElement("button");
  button.type = "button";
  button.className = "ls-option-reset-btn";
  button.dataset.resetKind = group;
  button.textContent = window.themeStrings?.reset_selection || "Reset";
  button.hidden = true;

  frame.classList.add("ls-has-reset-control");
  frame.appendChild(button);
}

function installStandardResetControls() {
  form.querySelectorAll(".variant-frame").forEach(frame => {
    const optionButton = frame.querySelector(".option-btn[data-option-group]");
    if (optionButton) addStandardResetControl(frame, optionButton.dataset.optionGroup);
  });
}

function syncStandardResetControls() {
  form.querySelectorAll(".ls-option-reset-btn").forEach(button => {
    const group = button.dataset.resetKind || "";
    button.hidden = !form.querySelector(`.option-btn[data-option-group="${group}"].active`);
  });
}

function resetStandardSelection(group) {
  if (group === "size") {
    clearStandardGroup("size");
    clearStandardGroup("base");

    const sizePreview = document.getElementById("size-preview");
    const basePreview = document.getElementById("base-preview");
    if (sizePreview) sizePreview.innerHTML = "";
    if (basePreview) basePreview.innerHTML = "";
  } else {
    clearStandardGroup(group);
    const preview = document.getElementById(`${group}-preview`);
    if (preview) preview.innerHTML = "";
  }

  updateVariantId();
  syncStandardResetControls();
}

optionButtons.forEach(btn => {
  btn.addEventListener("click", () => {
    const group = btn.dataset.optionGroup;

    form.querySelectorAll(`.option-btn[data-option-group="${group}"]`)
      .forEach(b => {
        b.classList.remove("active");
        b.setAttribute("aria-pressed", "false");
      });

    btn.classList.add("active");
    btn.setAttribute("aria-pressed", "true");

    const preview = document.getElementById(`${group}-preview`);
    const normGroup = normalizeOptionName(group);

    const canonicalVal = getCanonicalOptionValue(normGroup, btn.dataset.value);

    const key = `${productHandle}_${normGroup}_${canonicalVal}`;

    if (window.variantImages?.[key] && preview) {
      preview.innerHTML = `
        <img 
          src="${window.variantImages[key]}" 
          width="280" 
          height="280" 
          loading="lazy"
        >
      `;
    } else if (preview) {
      preview.innerHTML = "";
    }

    updateVariantId();
    syncStandardResetControls();
  });
});

function refreshVariantAvailability() {
  // Progressive option logic prevents a dead end:
  // Size is checked independently, Base is checked against Size,
  // and later options are checked only against the choices before them.
  // An incompatible dependent choice is cleared instead of locking the customer in.
  let pass = 0;
  let clearedSelection = false;

  do {
    clearedSelection = false;
    const selected = getSelectedVariantOptions();

    document.querySelectorAll(".option-btn[data-option-group]").forEach(btn => {
      const group = btn.dataset.optionGroup;
      const value = btn.dataset.value || "";
      const groupIndex = groupOrder.indexOf(group);

      if (groupIndex < 0 || groupIndex >= totalOptions) return;

      const exists = variants.some(variant => {
        for (let i = 0; i <= groupIndex; i++) {
          const wanted = i === groupIndex ? value : (selected[i] || "");
          if (!wanted) continue;

          const optionGroup = groupOrder[i] || "";
          if (
            getCanonicalOptionValue(optionGroup, variant.options[i]) !==
            getCanonicalOptionValue(optionGroup, wanted)
          ) {
            return false;
          }
        }

        return true;
      });

      btn.disabled = !exists;
      btn.classList.toggle("unavailable", !exists);

      if (!exists && btn.classList.contains("active")) {
        btn.classList.remove("active");
        btn.setAttribute("aria-pressed", "false");
        clearedSelection = true;
      }
    });

    pass += 1;
  } while (clearedSelection && pass <= totalOptions);
}

function updateVariantId() {
  refreshVariantAvailability();

  const selected = getSelectedVariantOptions();
  const chosenCount = selected.filter(Boolean).length;
  const allChosen = chosenCount === totalOptions;

  const priceEls = document.querySelectorAll(".sticky-cart-price");

  if (hintEl) {
    hintEl.style.display = allChosen ? "none" : "block";
  }

  if (addToCartBtn) {
    addToCartBtn.style.visibility = allChosen ? "visible" : "hidden";
    addToCartBtn.style.pointerEvents = allChosen ? "auto" : "none";
  }

  if (!allChosen) {
    const partialMatch = variants.find(v =>
      selected.every((sel, i) => {
        if (!sel) return true;
        const group = groupOrder[i] || "";
        return getCanonicalOptionValue(group, v.options[i]) === getCanonicalOptionValue(group, sel);
      })
    );

    if (partialMatch) {
      priceEls.forEach(el => {
        el.innerHTML = partialMatch.formatted_price || "";
      });
    }

    if (hiddenInput) hiddenInput.value = "";
    if (addToCartBtn) addToCartBtn.disabled = true;
  } else {
    const match = variants.find(v => arraysEqualCI(v.options, selected));

    if (match) {
      if (hiddenInput) hiddenInput.value = match.id;
      if (addToCartBtn) addToCartBtn.disabled = !match.available;

      priceEls.forEach(el => {
        if (
          match.formatted_compare_at_price &&
          Number(match.compare_at_price) > Number(match.price)
        ) {
          el.innerHTML = `
            <span class="price--compare"><s>${match.formatted_compare_at_price}</s></span>
            <span class="price--sale">${match.formatted_price}</span>
          `;
        } else {
          el.innerHTML = match.formatted_price || "";
        }
      });
    } else {
      if (hiddenInput) hiddenInput.value = "";
      if (addToCartBtn) addToCartBtn.disabled = true;
    }
  }
}

form.addEventListener("click", event => {
  const resetButton = event.target.closest(".ls-option-reset-btn");
  if (!resetButton) return;
  resetStandardSelection(resetButton.dataset.resetKind || "");
});


refreshVariantAvailability();
syncStandardResetControls();

/* ==================================
   SHIPPING ACCORDION
================================== */
const toggle = document.querySelector(".shipping-toggle");
const content = document.getElementById("shipping-content");

if (toggle && content) {
  toggle.addEventListener("click", () => {
    const open = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", !open);
    content.classList.toggle("open", !open);
  });
}

/* ==================================
   DILDO SIZE CHART LIGHTBOX
================================== */
let lastSizeChartTrigger = null;

function formatSizeChartNumber(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';

  return (Math.round(number * 100) / 100)
    .toFixed(2)
    .replace(/\.00$/, '')
    .replace(/(\.\d)0$/, '$1');
}

function parseSizeChartNumber(value) {
  if (value === null || value === undefined) return null;

  const cleaned = String(value)
    .replace(',', '.')
    .replace(/[^0-9.\-]/g, '')
    .trim();

  if (!cleaned) return null;

  const number = Number(cleaned);
  return Number.isFinite(number) ? number : null;
}

function getSizeChartCellCm(cell) {
  if (!cell) return null;
  const fromData = parseSizeChartNumber(cell.dataset.sizeCm);
  if (fromData !== null) return fromData;
  return parseSizeChartNumber(cell.textContent);
}

function setSizeChartCellCm(cell, value, calculated) {
  if (!cell || !Number.isFinite(value)) return;

  const cmValue = formatSizeChartNumber(value);
  const inchValue = formatSizeChartNumber(value / 2.54);

  cell.dataset.sizeCm = cmValue;
  cell.dataset.sizeCmLabel = cmValue;
  cell.dataset.sizeIn = inchValue;
  cell.dataset.sizeCalculated = calculated ? 'true' : 'false';
}

function initializeStaticDildoSizeChartTables() {
  document.querySelectorAll('[data-dildo-size-chart-table]').forEach(function (table) {
    const pairs = [
      ['tip_diameter', 'tip_circumference'],
      ['max_shaft_diameter', 'max_shaft_circumference'],
      ['base_diameter', 'base_circumference']
    ];

    pairs.forEach(function ([diameterKey, circumferenceKey]) {
      const diameterCells = table.querySelectorAll('[data-size-row="' + diameterKey + '"]');

      diameterCells.forEach(function (diameterCell) {
        const column = diameterCell.dataset.sizeColumn;
        const circumferenceCell = table.querySelector('[data-size-row="' + circumferenceKey + '"][data-size-column="' + column + '"]');
        if (!circumferenceCell) return;

        const diameter = getSizeChartCellCm(diameterCell);
        const circumference = getSizeChartCellCm(circumferenceCell);

        if (diameter === null && circumference !== null) {
          setSizeChartCellCm(diameterCell, circumference / Math.PI, true);
        }

        if (circumference === null && diameter !== null) {
          setSizeChartCellCm(circumferenceCell, diameter * Math.PI, true);
        }
      });
    });
  });
}

function setSizeChartUnit(modal, unit) {
  if (!modal) return;

  modal.querySelectorAll('[data-size-chart-unit]').forEach((button) => {
    const active = button.dataset.sizeChartUnit === unit;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  modal.querySelectorAll('[data-size-row][data-size-column]').forEach((cell) => {
    const cmValue = getSizeChartCellCm(cell);

    if (cmValue === null) {
      cell.textContent = '—';
      return;
    }

    if (unit === 'in') {
      cell.textContent = cell.dataset.sizeIn || formatSizeChartNumber(cmValue / 2.54);
    } else {
      cell.textContent = cell.dataset.sizeCmLabel || formatSizeChartNumber(cmValue);
    }
  });
}

function unlockSizeChartScroll() {
  document.documentElement.classList.remove('overflow-hidden');
  document.body.classList.remove('overflow-hidden');
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
}

function openSizeChartModal(modal, trigger) {
  if (!modal) return;

  lastSizeChartTrigger = trigger || null;
  initializeStaticDildoSizeChartTables();
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden');
  setSizeChartUnit(modal, 'cm');

  const focusTarget = modal.querySelector('[data-size-chart-close]') || modal.querySelector('.dildo-size-chart-lightbox-content');
  if (focusTarget) focusTarget.focus();
}

function closeSizeChartModal(modal) {
  if (!modal) return;

  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  unlockSizeChartScroll();

  if (lastSizeChartTrigger) {
    lastSizeChartTrigger.focus();
    lastSizeChartTrigger = null;
  }
}

initializeStaticDildoSizeChartTables();

document.addEventListener('click', function (e) {
  const openBtn = e.target.closest('[data-size-chart-open]');
  if (openBtn) {
    const modal = document.getElementById(openBtn.dataset.sizeChartOpen);
    openSizeChartModal(modal, openBtn);
    return;
  }

  const closeBtn = e.target.closest('[data-size-chart-close]');
  if (closeBtn) {
    closeSizeChartModal(closeBtn.closest('.dildo-size-chart-lightbox'));
    return;
  }

  const unitBtn = e.target.closest('[data-size-chart-unit]');
  if (unitBtn) {
    const modal = unitBtn.closest('.dildo-size-chart-lightbox');
    setSizeChartUnit(modal, unitBtn.dataset.sizeChartUnit);
    return;
  }

  const sizeChartModal = e.target.closest('.dildo-size-chart-lightbox');
  if (sizeChartModal && e.target === sizeChartModal) {
    closeSizeChartModal(sizeChartModal);
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  const openModal = document.querySelector('.dildo-size-chart-lightbox.open');
  if (openModal) closeSizeChartModal(openModal);
});

/* ==================================
   VARIANT “MORE INFORMATION” BUTTONS
================================== */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".variant-more-info-btn");
  if (!btn) return;

  const key = btn.dataset.info;
  const target = document.querySelector(
    `.variant-more-info-content[data-info-target="${key}"]`
  );
  if (!target) return;

  const isOpen = target.classList.contains("open");

  // Close all sections
  document
    .querySelectorAll(".variant-more-info-content")
    .forEach((section) => section.classList.remove("open"));

  document
    .querySelectorAll(".variant-more-info-btn")
    .forEach((button) => {
      if (window.themeStrings?.more_info) {
        button.textContent = window.themeStrings.more_info;
      }
      button.setAttribute("aria-expanded", "false");
    });

  // Open clicked section (if it was closed)
  if (!isOpen) {
    target.classList.add("open");
    if (window.themeStrings?.hide_info) {
      btn.textContent = window.themeStrings.hide_info;
    }
    btn.setAttribute("aria-expanded", "true");
  }
});

});
